import IndigenousArtwork from '@/images/Acknowledgement_of_Country.jpg';
import NationalInterpreterLogo from '@/images/National_Interpreter_Logo.svg';
import { Link, Typography } from '@mui/material';
import React from 'react';
import styles from './Footer.module.scss';

const Footer: React.FC = () => {
  const model = {
    AcknowledgementTitle: 'Acknowledgement of Country',
    AcknowledgementDescription:
      '<p>The Department of Home Affairs and the Australian Border Force acknowledge the Traditional Custodians of Country throughout Australia, their ancient living culture, and their continuing connection to land, sea and community. We pay our respects to all Aboriginal and Torres Strait Islander peoples, their cultures and to their Elders past and present.<p> Artwork: <em><a rel="noopener noreferrer" href="https://www.homeaffairs.gov.au/commitments/files/reconciliation-action-plan-2023-26.PDF#page=4" target="_blank" title="Protecting Country and People, Luke Penrith">Protecting Country and People,</a></em><a rel="noopener noreferrer" href="https://www.homeaffairs.gov.au/commitments/files/reconciliation-action-plan-2023-26.PDF#page=4" target="_blank" title="Protecting Country and People, Luke Penrith">&nbsp;Luke Penrith, July 2022</a></p>',
    LinkLine1: [
      {
        LinkSelector: {
          Text: 'Contact us',
          Url: 'https://www.tisnational.gov.au/Contact-us',
          Target: '_blank',
        },
      },
      {
        LinkSelector: {
          Text: 'Provide feedback',
          Url: 'https://www.tisnational.gov.au/Who-we-are/Provide-feedback',
          Target: '_blank',
        },
      },
      {
        LinkSelector: {
          Text: 'Multicultural access and equity',
          Url: 'https://www.tisnational.gov.au/Policies/Multicultural-Access-and-Equity',
          Target: '_blank',
        },
      },
      {
        LinkSelector: {
          Text: 'Accessibility',
          Url: 'https://www.tisnational.gov.au/Who-we-are/Accessibility',
          Target: '_blank',
        },
      },
    ],
    LinkLine2: [
      {
        LinkSelector: {
          Text: 'Terms and Conditions of use',
          Url: 'https://www.tisnational.gov.au/Policies/Terms-and-Conditions',
          Target: '_blank',
        },
      },
      {
        LinkSelector: {
          Text: 'Copyright Notice',
          Url: 'https://www.tisnational.gov.au/Policies/Copyright-Notice',
          Target: '_blank',
        },
      },
      {
        LinkSelector: {
          Text: 'Security',
          Url: 'https://www.tisnational.gov.au/Policies/Security-Notice',
          Target: '_blank',
        },
      },
      {
        LinkSelector: {
          Text: 'Sitemap',
          Url: 'https://www.tisnational.gov.au/Sitemap',
          Target: '_blank',
        },
      },
      {
        LinkSelector: {
          Text: 'Privacy Notice',
          Url: 'https://www.tisnational.gov.au/Policies/Privacy-Notice',
          Target: '_blank',
        },
      },
    ],
  };

  return (
    <footer className={styles.footer}>
      <div className={styles.acknowledgement}>
        <div className={styles.acknowledgementContainer}>
          <div className={styles.acknowledgementContent}>
            <Typography variant="h3">{model.AcknowledgementTitle}</Typography>
            <Typography
              variant="body1"
              dangerouslySetInnerHTML={{
                __html: model.AcknowledgementDescription,
              }}
            />
          </div>
          <div className={styles.acknowledgementArtwork}>
            <div className={styles.acknowledgementArtworkInner}>
              <img src={IndigenousArtwork} alt="Indigenous artwork" />
              <div className={styles.acknowledgementArtworkOverlay}></div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.firstRow}>
        <div className={styles.firstRowContainer}>
          <div className={styles.firstRowInner}>
            <ul>
              {model.LinkLine1.map((link, index) => (
                <li key={index}>
                  <Link
                    aria-label={link.LinkSelector.Text}
                    href={link.LinkSelector.Url}
                    target={link.LinkSelector.Target}
                  >
                    {link.LinkSelector.Text}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className={styles.nationalInterpreter}>
            <Link
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Learn more"
              href="https://immi.homeaffairs.gov.au/settling-in-australia/settle-in-australia/language-services/national-interpreter-symbol"
            >
              <img
                alt="National Interpreter Logo"
                src={NationalInterpreterLogo}
              />
            </Link>
          </div>
          <div className={styles.trapezoidBackground}></div>
        </div>
      </div>
      <div className={styles.secondRow}>
        <div className={styles.secondRowContainer}>
          <ul>
            {model.LinkLine2.map((link, index) => (
              <li key={index}>
                <Link
                  aria-label={link.LinkSelector.Text}
                  href={link.LinkSelector.Url}
                  target={link.LinkSelector.Target}
                >
                  {link.LinkSelector.Text}
                </Link>
              </li>
            ))}
          </ul>
          <span>Version 0.0.1</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
